import React from "react";
import { motion } from "framer-motion";
import RollingNumber from "./RollingNumber";
import { VictoryPhase } from "./types";
import { useTheme } from "../../contexts/ThemeContext";

interface LiquidityCounterProps {
  value: number;
  side: "left" | "right";
  victoryPhase: VictoryPhase;
  isEliminated: boolean;
  isDead: boolean;
}

const LiquidityCounter: React.FC<LiquidityCounterProps> = ({
  value,
  side,
  victoryPhase,
  isEliminated,
  isDead,
}) => {
  const { colors } = useTheme();
  const isTransferring = victoryPhase === "transfer";

  // Simplified - only text color changes based on state
  const getTextColor = () => {
    if (isDead) return "text-gray-400";
    if (isEliminated && isTransferring) return "text-red-400";
    if (!isEliminated && isTransferring) return "text-green-300";
    return "text-white";
  };

  return (
    <motion.div
      className={`absolute top-0 z-20 rounded-full ${
        side === "left" ? "left-0" : "right-0"
      }`}
    >
      <div
        className={`
          relative px-4 py-3 h-8 sm:h-9 md:h-10 w-[7rem]
          rounded-full
          bg-black/20
          flex items-center justify-center
          transition-all duration-300
        `}
      >
        {/* Subtle inner glow overlay */}
        <div
          className={`
            absolute inset-0 rounded-full
            ${
              !isDead && !isEliminated && isTransferring
                ? side === "left"
                  ? colors.teamA.bg
                  : colors.teamB.bg
                : ""
            }
          `}
        />

        {/* Value display */}
        <div className="relative">
          <RollingNumber
            value={Math.round(value)}
            duration={300}
            className={`text-sm sm:text-base md:text-lg font-bold font-mono whitespace-nowrap ${getTextColor()} transition-colors duration-300`}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default LiquidityCounter;
